var map = {
	"./bg.jpg": "f0ec",
	"./gs1.png": "d8ad",
	"./gs2.png": "e658",
	"./gs3.png": "1d08",
	"./jej1.png": "ed64",
	"./jej2.jpg": "eb30",
	"./jej3.png": "821a",
	"./jej4.png": "50cb",
	"./jej5.png": "047c",
	"./jjfa.png": "96c5",
	"./jz1.png": "458a",
	"./jz2.png": "8dbc",
	"./jz3.png": "b8a8",
	"./jz4.png": "5096",
	"./pro1.jpg": "0a81",
	"./pro2.jpg": "d53f",
	"./pro3.jpg": "a220",
	"./pro4.jpg": "c55f",
	"./pro_bg.jpg": "eb05",
	"./service.jpg": "ac96",
	"./我们/新版-定价_背景.jpg": "0779",
	"./我们/新版-我们-介绍_02.jpg": "6d1d7",
	"./我们/新版-我们-愿景_02.jpg": "6d1d72",
	"./我们/新版-我们_背景.jpg": "07796",
	"./首页/亮点1_03.jpg": "3567",
	"./首页/亮点2_03.jpg": "35671",
	"./首页/亮点3_03.jpg": "35671f",
	"./首页/评论1_03.jpg": "37b1",
	"./首页/评论2_03.jpg": "37b12",
	"./首页/评论3_03.jpg": "37b12f",
	"./首页/评论4_03.jpg": "37b12f0",
	"./首页/首页-banner_03.png": "8f23",
	"./首页/首页-企业_02.jpg": "df3f",
	"./首页/首页_02.jpg": "f79f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f353";